export const initialReportsState = {
  items: [],
}

export default {
  items: [],
}
